export default __webpack_public_path__ + "static/media/instagram-blue.9fe0d4c4.svg";